const Texts = {};

export default Texts;
